// Admin Bookings - placeholder
export default function AdminBookings() { return <div><h1 className="text-3xl font-bold">Bookings Management</h1><p className="mt-4">Manage all bookings here.</p></div>; }